import { AvatarUpload } from '@/features/profile/components/AvatarUpload'
import { ProfileForm } from '@/features/profile/components/ProfileForm'
import { UsernameForm } from '@/features/profile/components/UsernameForm'
import { DangerZone } from '@/features/profile/components/DangerZone'
import { PrivacySettings } from '@/features/social/components/PrivacySettings'
import { PushToggle } from '@/features/notifications/components/PushToggle'
import { useTranslation } from 'react-i18next'

export function ProfilePage() {
  const { t } = useTranslation()
  return (
    <div id="main-content" className="min-h-screen bg-surface-50">
      <div className="mx-auto max-w-2xl px-4 py-10">
        <h1 className="text-2xl font-bold text-neutral-900 mb-8">{t('profile.page_title')}</h1>

        <div className="flex flex-col gap-6">
          <section className="rounded-2xl border border-surface-200 bg-white p-6">
            <AvatarUpload />
          </section>

          <section className="rounded-2xl border border-surface-200 bg-white p-6">
            <ProfileForm />
          </section>

          <section className="rounded-2xl border border-surface-200 bg-white p-6">
            <UsernameForm />
          </section>

          <section className="rounded-2xl border border-surface-200 bg-white p-6">
            <PrivacySettings />
          </section>

          <section className="rounded-2xl border border-surface-200 bg-white p-6">
            <PushToggle />
          </section>

          <DangerZone />
        </div>
      </div>
    </div>
  )
}
